import {E} from "js-vextensions";
import React from "react";
import {BaseComponent, GetDOM} from "react-vextensions";
import useResizeObserver from "use-resize-observer";
import {Observer, PageContainer, RunInAction_Set} from "web-vcore";
import {store} from "../../../Store/index.js";
import {BottomPanelSubpanel, entityCellWidthTarget, OverlayPanel} from "../../../Store/main/tools/journey.js";
import {nativeBridge} from "../../../Utils/Bridge/Bridge_Native.js";
import {useExpandedNavBar} from "../../@Shared/NavBar.js";
import {SessionPeriodsUI} from "./SessionPeriodsUI.js";
import {JBottomPanel} from "./JBottomPanel.js";
import {JBanner} from "./JBanner.js";
import {GetSelectedEngineConfig} from "../../../Server/DB/engineConfigs.js";
import {GetEntities} from "../../../Server/DB/entities.js";
import {GetLights} from "../../../Server/DB/lights.js";
import {DoorwayOverlay} from "./Overlays/DoorwayOverlay.js";
import {CanvasOverlay} from "./Overlays/CanvasOverlay.js";
import {LockOverlay} from "./Overlays/LockOverlay.js";
import {observer_mgl} from "mobx-graphlink";
import {Div} from "react-vcomponents";
import {RecallGridOverlay} from "./Overlays/RecallGridOverlay.js";

//export const journeyPanelHeights = [0, 50, 50, 0];

export var sessionUIActive = false;
export var lockOverlayActive = false;
export function SetSessionUIActive(active: boolean) {
	sessionUIActive = active;
	UpdateSystemUIVisibility();
}
export function SetLockOverlayActive(active: boolean) {
	lockOverlayActive = active;
	UpdateSystemUIVisibility();
}
export function UpdateSystemUIVisibility() {
	const fbaConfig = GetSelectedEngineConfig.CatchBail(null);
	if (fbaConfig == null) return;
	const config = fbaConfig?.general;
	if (config == null) return;
	if (lockOverlayActive) {
		nativeBridge.Call("SetSystemUIVisibility", !config.lockOverlay_hideStatusBar, !config.lockOverlay_hideNavBar);
	} else if (sessionUIActive) {
		nativeBridge.Call("SetSystemUIVisibility", !config.sessionUI_hideStatusBar, !config.sessionUI_hideNavBar);
	} else {
		nativeBridge.Call("SetSystemUIVisibility", true, true);
	}
}

export const JSessionUI = observer_mgl(()=>{
	React.useEffect(()=>{
		SetSessionUIActive(true);
		return ()=>SetSessionUIActive(false);
	}, []);

	const uiState = store.main.engine.journey;
	const largeVersion = useExpandedNavBar();

	const {ref: rootRef, width = -1, height = -1} = useResizeObserver({onResize: e=>{
		const newWidth = e.width!.FloorTo(1);
		const newColumnCount = (e.width! / entityCellWidthTarget).FloorTo(3).KeepAtLeast(9) + 1;
		if (newWidth != e.width || newColumnCount != uiState.entities.entityCellColumns) {
			RunInAction_Set(uiState, ()=>{
				uiState.entities.entityCellContainerWidth = newWidth;
				uiState.entities.entityCellColumns = newColumnCount;
			});
		}
	}});

	const entities = GetEntities();
	const lights = GetLights();

	return (
		<>
			{uiState.overlay == OverlayPanel.normal && <LockOverlay/>}
			{uiState.overlay == OverlayPanel.canvas && <CanvasOverlay/>}
			{uiState.overlay == OverlayPanel.doorway && <DoorwayOverlay/>}
			{uiState.overlay == OverlayPanel.recallGrid && <RecallGridOverlay/>}
			<PageContainer preset={JSessionUI_Full() ? "full" : "text"}
				ref={c=>{
					//rootRef["current" as any] = c?.root?.root; // force-set
					rootRef["current" as any] = c?.root; // force-set
				}}
				style={E(
					{position: "relative", padding: 0, width: "100%", height: "100%"} as const,
					JSessionUI_Full() && {
						height: "calc(100% - 30px)",
						background: `rgba(0,0,0,.8)`,
					},
					!largeVersion && {margin: "0 auto 0 auto"},
				)}
			>
				<JBanner/>
				<SessionPeriodsUI/>
				{uiState.showBottomPanel && <JBottomPanel/>}
			</PageContainer>
		</>
	);
});

export function JSessionUI_Full() {
	const uiState = store.main.engine.journey;
	if (uiState.bottomPanelSubpanel == BottomPanelSubpanel.llm && uiState.llm.showLLMOutputOnSide) return true;
	return false;
}